module.exports = __webpack_public_path__ + "static/media/table-b.9b76d66a.svg";